/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SbbIconModule } from '@sbb-esta/angular-core/icon';
import { SbbDropdownModule } from '@sbb-esta/angular-business/dropdown';

import { SbbBreadcrumb } from './breadcrumb/breadcrumb.component';
import { SbbBreadcrumbs } from './breadcrumbs/breadcrumbs.component';

@NgModule({
  declarations: [SbbBreadcrumbs, SbbBreadcrumb],
  imports: [CommonModule, SbbDropdownModule, LayoutModule, SbbIconModule],
  exports: [SbbBreadcrumbs, SbbBreadcrumb],
})
export class SbbBreadcrumbModule {}
